module.exports = __webpack_public_path__ + "51b358baa16776c98a37b58766e5b5c0.jpg";